const ITEM_HEIGHT = 45
const ITEM_PADDING_TOP = 0
export const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP,
			width: 250,
			padding: ITEM_PADDING_TOP
		}
	}
}
export const RegisterStyle = theme => ({
	labelAsterisk: {
		color: "red"
	},
	paper: {
		width: "632px",
		maxWidth: "632px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px ${theme
			.spacing.unit * 3}px`
	},
	paper1: {
		display: "flex",
		flexDirection: "column",
		alignItems: "left",
		padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px ${theme
			.spacing.unit * 3}px`
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing.unit
	},
	FormControl: {
		marginTop: theme.spacing.unit
	},
	typographytitle: { marginTop: theme.spacing.unit * 3, textAlign: "center" },
	ckeckbox: {
		float: "left",
		margin: "0px 0px",
		marginLeft: "5px",
		padding: "5px"
	},
	Typography: {
		paddingTop: "16px"
	},
	root: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap"
	},
	wrapper: {
		position: "relative",
		width: "100%"
	},
	buttonProgress: {
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12
	},
	buttonProgress1: {
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -16,
		marginLeft: -12
	},
	formControl: {
		margin: theme.spacing.unit * 3
	},
	group: {
		margin: `${theme.spacing.unit}px 0`
	}
})
